module.exports = __webpack_public_path__ + "static/img/third19.6a9ace37.png";